// eslint-disable-next-line no-unused-vars
import React, { memo, useEffect, useRef, useState } from 'react';
import { bool } from 'prop-types';

import AuthHOC from 'Containers/Auth/Auth';
import UserMenuComponent from 'Components/Menus/User';
import useOutsideClick from 'Hooks/useOutsideClick';
import useRouter from 'Hooks/useRouter';
import useAccount from 'Hooks/useAccount';
import useUser from 'Hooks/useUser';
import usePermissions from 'Hooks/usePermissions';
import useScrollLock from 'Hooks/useScrollLock';
import { CURRENCY_RON } from 'Constants';

const UserMenu = memo(({ canFloat }) => {
  const [open, setOpen] = useState(false);
  const { data: user, userLogout, isLoading } = useUser();
  const { credit, creditLoading, sold, soldLoading } = useAccount();
  const ref = useRef();
  const { location } = useRouter();
  const isVisible = useOutsideClick(ref);

  const { isExternalReseller } = usePermissions();
  const defaultCurrency = isExternalReseller ? user?.defaultCurrency : CURRENCY_RON;

  useEffect(() => {
    setOpen(isVisible);
  }, [isVisible]);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const handleOnToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  useScrollLock(open);

  return (
    <AuthHOC>
      <UserMenuComponent
        ref={ ref }
        open={ open }
        user={ user }
        onToggle={ handleOnToggle }
        setDropdown={ setOpen }
        onLogout={ userLogout }
        isExternalReseller={ isExternalReseller }
        defaultCurrency={ defaultCurrency }
        credit={ credit }
        creditLoading={ creditLoading }
        sold={ sold }
        soldLoading={ soldLoading }
        dueDays={ user?.paymentDueDays }
        canFloat={ canFloat }
        isLoading={ isLoading }
      />
    </AuthHOC>
  );
});

UserMenu.displayName = 'UserMenuContainer';

UserMenu.propTypes = {
  canFloat: bool,
};

export default UserMenu;
